import { concat } from '@ember/helper'
import { get } from '@ember/helper'
import { Product } from 'district-ui-client/domain/product'
import { t } from 'ember-intl'
import Component from '@glimmer/component'
import type { TOC } from '@ember/component/template-only'

interface ProductPillSignature {
  Element: HTMLDivElement
  Args: {
    product: Product
  }
}

const background: Record<Product, string> = {
  [Product.RE]: 'bg-purply-pink-100',
  [Product.REX]: 'bg-purply-pink-100',
  [Product.FP]: 'bg-purply-pink-100',
  [Product.MS]: 'bg-oceany-blue-100',
  [Product.MSP]: 'bg-oceany-blue-100',
  [Product.MX]: 'bg-oceany-blue-100',
  [Product.WL]: 'bg-forest-green-100',
}

const text: Record<Product, string> = {
  [Product.RE]: 'text-purply-pink-350',
  [Product.REX]: 'text-purply-pink-350',
  [Product.FP]: 'text-purply-pink-350',
  [Product.MS]: 'text-oceany-blue-400',
  [Product.MSP]: 'text-oceany-blue-400',
  [Product.MX]: 'text-oceany-blue-400',
  [Product.WL]: 'text-ms-green-400',
}

export const ProductPill: TOC<ProductPillSignature> = <template>
  <div
    class="{{get background @product}}
      {{get text @product}}
      inline-block whitespace-nowrap rounded-full px-2.5 py-1.5 align-middle text-sm font-semibold uppercase"
    ...attributes
  >
    {{t (concat "products." @product)}}
  </div>
</template>

interface PillSignature {
  Element: HTMLButtonElement
  Args: {
    theme?: 'default' | 'neutral'
    class?: string[]
    disabled?: boolean
  }
  Blocks: {
    default: []
  }
}

export class Pill extends Component<PillSignature> {
  baseClass = []
  neutralClass = []
  defaultClass = []

  get isNeutral() {
    return this.args.theme === 'neutral' || this.args.disabled
  }

  <template>
    <button
      type="button"
      class={{concat
        "inline-flex cursor-auto items-center space-x-2 whitespace-nowrap rounded-full bg-neutral-50 px-3 py-1.5 text-center text-sm font-normal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-325"
        (if
          this.isNeutral
          "bg-neutral-50 text-neutral-300 hover:bg-neutral-75 focus:bg-neutral-50"
          "hover:bg-blue-125 !bg-blue-100 text-blue-350 focus:bg-blue-100"
        )
        (concat @class)
      }}
      ...attributes
    >
      {{yield}}
    </button>
  </template>
}
